import {useSelector} from 'react-redux';
import {
  selectIsFilledUyo,
  selectIsPristineUyo,
  selectOriginalFabricArt,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

export const useUyo = () => {
  const pristineUyo = useSelector(selectIsPristineUyo);
  const canvasJson = useSelector(selectOriginalFabricArt);
  const isFilledUyo = useSelector(selectIsFilledUyo);
  const isFullDyo = useSelector(({fabricTemplate}) =>
    ['general-full', 'dyo'].every((el) => fabricTemplate.templateName.includes(el))
  );
  const isUyo = !!canvasJson.objects?.find((obj) => obj.type === 'uYOImage');

  return {isUyo, pristineUyo, isFullDyo, isFilledUyo};
};
